import {GET_BOOK_LIST} from '../constants/storyBooks';

export const booklist = (initialState = [], action) => {
    switch (action.type) {
        case GET_BOOK_LIST:
            return action.books;
        default:
            return initialState;
    }
}